<app-crear-editar
  icono="person"
  [loading]="!form"
  title="Configurar Usuario"
  [subtitle]="usuario?.usuario"
>
  @if (form) {
    <form
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
      class="config-form"
      id="form"
    >
      <!-- Datos personales -->
      <app-content-card
        title="Datos Personales"
        icon="account_circle"
        color="green"
        [formGroup]="datosPersonales"
      >
        <!-- Nombre - DNI - SEXO -->
        <section class="inputs-group">
          <!-- Nombre Completo -->
          <mat-form-field style="width: 100%">
            <mat-label>Nombre Completo</mat-label>
            <input matInput formControlName="nombre" />
            <mat-icon matPrefix>person_outline</mat-icon>
          </mat-form-field>
          <!-- DNI -->
          <mat-form-field style="width: 100%">
            <mat-label>DNI</mat-label>
            <input matInput formControlName="dni" />
            <mat-icon matPrefix>badge</mat-icon>
          </mat-form-field>
          <!-- Sexo -->
          <ng-select
            style="width: 100%"
            formControlName="sexo"
            placeholder="Sexo"
            [items]="sexos"
            bindLabel="label"
            bindValue="value"
            appendTo="body"
            notFoundText="Sin resultados"
          ></ng-select>
        </section>

        <!-- EMAIL - DIRECCIÓN -->
        <section class="inputs-group">
          <!-- Email -->
          <mat-form-field style="width: 100%">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" />
            <mat-icon matPrefix>email</mat-icon>
          </mat-form-field>
          <!-- Direccion -->
          <mat-form-field style="width: 100%">
            <mat-label>Dirección</mat-label>
            <input matInput formControlName="direccion" />
            <mat-icon matPrefix>place</mat-icon>
          </mat-form-field>
        </section>

        <!-- TELÉFONO - FECHA DE NACIMIENTO -->
        <section class="inputs-group">
          <!-- Telefono -->
          <mat-form-field style="width: 100%">
            <mat-label>Teléfono</mat-label>
            <input matInput formControlName="telefono" />
            <mat-icon matPrefix>phone</mat-icon>
          </mat-form-field>
          <!-- Fecha de nacimiento -->
          <mat-form-field style="width: 100%">
            <mat-label>Fecha de Nacimiento</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="fechaNacimiento"
              [max]="hoy"
            />
            <mat-icon matPrefix>cake</mat-icon>
            <mat-hint>DD/MM/YYYY</mat-hint>
            <button
              irxBotonIcono
              tamano="compacto"
              matIconSuffix
              tooltip="Elegir fecha"
              (click)="picker.open()"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
            <mat-datepicker #picker startView="multi-year"></mat-datepicker>
          </mat-form-field>
        </section>

        <!-- Foto -->
        <section class="inputs-group">
          <div class="grow1 upload-section" style="text-align: center">
            <app-section-title
              title="Foto de Perfil"
              icon="photo_camera"
              color="green"
            ></app-section-title>

            <app-upload-file
              [url]="urlFoto"
              (urlChange)="onFotoChange($event)"
              textoBoton="Seleccionar Foto"
              [allowMultiple]="false"
              [maxFiles]="1"
            ></app-upload-file>
          </div>
        </section>
      </app-content-card>

      <!-- Credenciales de seguridad (usuario de monitoreo → permiso activo) -->
      @if (mostrarCredenciales) {
        <app-content-card
          title="Credenciales de Seguridad"
          icon="key"
          color="orange"
          [formGroup]="credenciales"
        >
          @if (!esNivel0) {
            <p class="cred-info">
              Usuario de monitoreo para
              <strong>
                {{ permisoActual?.cliente?.nombre || permisoActual?.idCliente }}
              </strong>
              @if (tieneCredenciales) {
                <span class="cred-estado cred-ok">
                  <mat-icon>check_circle</mat-icon>
                  Configuradas
                </span>
              } @else {
                <span class="cred-estado cred-pendiente">
                  <mat-icon>info</mat-icon>
                  Sin configurar
                </span>
              }
            </p>
          }

          <section class="inputs-group">
            <!-- Usuario de monitoreo -->
            <mat-form-field>
              <mat-label>Usuario de monitoreo</mat-label>
              <input matInput formControlName="usuario" autocomplete="off" />
              <mat-icon matPrefix>person</mat-icon>
            </mat-form-field>

            <!-- Clave -->
            <mat-form-field>
              <mat-label>Clave</mat-label>
              <input
                matInput
                formControlName="clave"
                [type]="credInputType"
                autocomplete="new-password"
              />
              <mat-icon matPrefix>lock</mat-icon>
              <button
                irxBotonIcono
                matSuffix
                [tooltip]="
                  credInputType === 'password'
                    ? 'Mostrar clave'
                    : 'Ocultar clave'
                "
                (click)="toggleCredPassword()"
              >
                <mat-icon>
                  {{
                    credInputType === 'password'
                      ? 'visibility'
                      : 'visibility_off'
                  }}
                </mat-icon>
              </button>
              <mat-hint>Dejar vacío para no cambiar la clave</mat-hint>
            </mat-form-field>
          </section>
        </app-content-card>
      }
    </form>
  }

  <ng-container actions>
    <app-button
      matType="mat-fab extended"
      color="neutral"
      (click)="volver()"
      text="Cancelar"
      icon="close"
    ></app-button>
    <app-button
      matType="mat-fab extended"
      [disabled]="!this.form?.valid || loading"
      color="primary"
      text="Guardar"
      icon="save"
      type="submit"
      [formId]="'form'"
    ></app-button>
  </ng-container>
</app-crear-editar>
